<template>
  <div style="overflow: hidden;">
  <div class="allPage" id="survivalDetail" v-cloak>
    <van-pull-refresh class="refresh-box pullStyle" id="refresh-box" v-model="isLoading" @refresh="onRefresh"
        success-text="刷新成功" :head-height="54">
    <div class="primaryPage" id="allPage">
      <div class="fundDetail">
        <div class="fund-name">
          <div class="fundN">{{ dataObj.fundName }}</div>
          <div class="fundLabel">
            <div class="fundC">{{ dataObj.fundCode }}</div>
            <div class="risk" v-if="!!riskLevel">
              <img
                v-if="showRiskImg === true"
                src="@/assets/images/header/riskBg.png"
                class="risk_img"
              />
              <span class="risk_txt"> {{ riskLevel }} </span>
            </div>
            <div class="risk" v-if="!!fundType">
              <span class="risk_txt"> {{ fundType }} </span>
            </div>
          </div>
        </div>
        <div class="investmentT" v-if="!isMonetaryFund">
          <div class="investmentT__des" @click="entryInvestment">投资检视</div>
        </div>
        <div class="allSurvival">
          <span class="allSurvival__span">持有金额 (元)</span>
          <van-icon name="question-o" @click="toastInfo" />
        </div>
        <div class="allSurvival" v-if="dataObj.lockTitle">
          <span class="allSurvival__tag">{{ dataObj.lockTitle }}</span>
        </div>
        <div class="mineSurvival">
          <template v-if="getValueStatus(positionAmount) == '4'">
            <div class="mineSurvival__Num normal">--</div>
          </template>
          <template v-else>
            <div class="mineSurvival__Num">
              {{ positionAmount | formatMoney }}
            </div>
          </template>
        </div>
        <div class="lockingShare" @click="toShareDetail" v-if="dataObj.lockInShare">
          <span class="lockingShare__span">锁定份额 <span class="lockingShare__count">{{ dataObj.lockInShare | formatMoney }}</span> 份</span>
        </div>
        <div class="survivalList" v-if="!isHistoryData">
          <div class="survivalList__item">
            <div class="top">昨日收益</div>
            <template v-if="getValueStatus(yesterdaySEarnings) == '1'">
              <div class="bottom green">
                {{ yesterdaySEarnings | formatMoney }}
              </div>
            </template>
            <template v-if="getValueStatus(yesterdaySEarnings) == '2'">
              <div class="bottom">{{ yesterdaySEarnings | formatMoney }}</div>
            </template>
            <template v-if="getValueStatus(yesterdaySEarnings) == '4'">
              <div class="bottom">--</div>
            </template>
            <template v-if="getValueStatus(yesterdaySEarnings) == '3'">
              <div class="bottom red">
                +{{ yesterdaySEarnings | formatMoney }}
              </div>
            </template>
          </div>
          <div class="survivalList__item">
            <div class="top">持有收益</div>
            <template v-if="getValueStatus(positionIncome) == '1'">
              <div class="bottom green">{{ positionIncome | formatMoney }}</div>
            </template>
            <template v-if="getValueStatus(positionIncome) == '2'">
              <div class="bottom">{{ positionIncome | formatMoney }}</div>
            </template>
            <template v-if="getValueStatus(positionIncome) == '4'">
              <div class="bottom">--</div>
            </template>
            <template v-if="getValueStatus(positionIncome) == '3'">
              <div class="bottom red">+{{ positionIncome | formatMoney }}</div>
            </template>
          </div>
          <div class="survivalList__item">
            <div class="top">持有收益率</div>
            <template v-if="getValueStatus(holdingRateOfReturn) == '1'">
              <div class="bottom green">
                {{ holdingRateOfReturn | formatMoney }}%
              </div>
            </template>
            <template v-if="getValueStatus(holdingRateOfReturn) == '2'">
              <div class="bottom">{{ holdingRateOfReturn | formatMoney }}%</div>
            </template>
            <template v-if="getValueStatus(holdingRateOfReturn) == '4'">
              <div class="bottom">--</div>
            </template>
            <template v-if="getValueStatus(holdingRateOfReturn) == '3'">
              <div class="bottom red">
                +{{ holdingRateOfReturn | formatMoney }}%
              </div>
            </template>
          </div>
        </div>
        <div class="survivalList" v-else>
          <div class="survivalList__item" style="width:50%">
            <div class="top">清仓收益</div>
            <template v-if="getValueStatus(cumulativeIncome) == '1'">
              <div class="bottom green">{{ cumulativeIncome | formatMoney }}</div>
            </template>
            <template v-if="getValueStatus(cumulativeIncome) == '2'">
              <div class="bottom">{{ cumulativeIncome | formatMoney }}</div>
            </template>
            <template v-if="getValueStatus(cumulativeIncome) == '4'">
              <div class="bottom">--</div>
            </template>
            <template v-if="getValueStatus(cumulativeIncome) == '3'">
              <div class="bottom red">+{{ cumulativeIncome | formatMoney }}</div>
            </template>
          </div>
          <div class="survivalList__item" style="width:50%">
            <div class="top">清仓收益率</div>
            <template v-if="getValueStatus(cumulativeRate) == '1'">
              <div class="bottom green">
                {{ cumulativeRate.toFixed(2)}}%
              </div>
            </template>
            <template v-if="getValueStatus(cumulativeRate) == '2'">
              <div class="bottom">{{ cumulativeRate | formatMoney }}%</div>
            </template>
            <template v-if="getValueStatus(cumulativeRate) == '4'">
              <div class="bottom">--</div>
            </template>
            <template v-if="getValueStatus(cumulativeRate) == '3'">
              <div class="bottom red">
                +{{ cumulativeRate.toFixed(2)}}%
              </div>
            </template>
          </div>
        </div>
        <div class="dropMore">
          <van-icon
            name="arrow-down"
            @click="showDropContent = true"
            v-show="!showDropContent"
          />
          <van-icon
            name="arrow-up"
            @click="showDropContent = !showDropContent"
            v-show="showDropContent"
          />
        </div>
        <div class="dropMoreDetail" v-show="showDropContent && !isMonetaryFund && !isHistoryData">
          <div class="dropList width60">
            <div class="dropList__left">最新净值</div>
            <div class="dropList__right">
              {{ dataObj.latestNetWorth }}({{
                formatDate(dataObj.netWorthDate)
              }})
            </div>
          </div>
          <div class="dropList width40">
            <div class="dropList__left">持有份额</div>
            <div
              class="dropList__right"
              v-if="getValueStatus(dataObj.holdShare) == '4'"
            >
              --
            </div>
            <div class="dropList__right" v-else>{{ dataObj.holdShare }}</div>
          </div>
          <div class="dropList width60">
            <div class="dropList__left">日涨幅</div>
            <template v-if="getValueStatus(dailyIncrease) == '1'">
              <div class="dropList__right reduceStyle">
                {{ dailyIncrease }}%
              </div>
            </template>
            <template v-if="getValueStatus(dailyIncrease) == '2'">
              <div class="dropList__right">0.00%</div>
            </template>
            <template v-if="getValueStatus(dailyIncrease) == '4'">
              <div class="dropList__right">--</div>
            </template>
            <template v-if="getValueStatus(dailyIncrease) == '3'">
              <div class="dropList__right addStyle">+{{ dailyIncrease }}%</div>
            </template>
          </div>
          <div class="dropList width40">
            <div class="dropList__left">成本净值</div>
            <div
              class="dropList__right"
              v-if="getValueStatus(dataObj.netCost) == '2'"
            ></div>
            <div
              class="dropList__right"
              v-if="getValueStatus(dataObj.netCost) == '4'"
            >
              --
            </div>
            <div class="dropList__right" v-else>
              {{ dataObj.netCost ? (dataObj.netCost * 1).toFixed(4) : "" }}
            </div>
          </div>
          
          <div class="dropList width60">
            <div class="dropList__left">浮动盈亏</div>
            <template v-if="getValueStatus(cumulativeIncome) == '1'">
              <div class="dropList__right reduceStyle">
                {{ cumulativeIncome }}({{cumulativeRate.toFixed(2)}}%)
              </div>
            </template>
            <template v-if="getValueStatus(cumulativeIncome) == '2'">
              <div class="dropList__right">0.00</div>
            </template>
            <template v-if="getValueStatus(cumulativeIncome) == '4'">
              <div class="dropList__right">--</div>
            </template>
            <template v-if="getValueStatus(cumulativeIncome) == '3'">
              <div class="dropList__right addStyle">+{{ cumulativeIncome }}(+{{cumulativeRate.toFixed(2)}}%)</div>
            </template>
          </div>
          <div class="dropList width60">
            <div class="dropList__left">累计现金分红金额</div>
            <template v-if="getValueStatus(cashDividendAmount) == '1'">
              <div class="dropList__right reduceStyle">
                {{ cashDividendAmount }}
              </div>
            </template>
            <template v-if="getValueStatus(cashDividendAmount) == '2'">
              <div class="dropList__right">0.00</div>
            </template>
            <template v-if="getValueStatus(cashDividendAmount) == '4'">
              <div class="dropList__right">--</div>
            </template>
            <template v-if="getValueStatus(cashDividendAmount) == '3'">
              <div class="dropList__right addStyle">+{{ cashDividendAmount }}</div>
            </template>
          </div>

          <div class="dropList width60" v-if="monthKnot">
            <div class="dropList__left">未兑付收益</div>
            <template v-if="getValueStatus(unpaidEarnings) == '1'">
              <div class="dropList__right reduceStyle">
                {{ unpaidEarnings }}
              </div>
            </template>
            <template v-if="getValueStatus(unpaidEarnings) == '2'">
              <div class="dropList__right">0.00</div>
            </template>
            <template v-if="getValueStatus(unpaidEarnings) == '4'">
              <div class="dropList__right">--</div>
            </template>
            <template v-if="getValueStatus(unpaidEarnings) == '3'">
              <div class="dropList__right addStyle">+{{ unpaidEarnings }}</div>
            </template>
          </div>

        </div>
        <div class="dropMoreDetail" v-show="showDropContent && !isMonetaryFund && isHistoryData">
          <div class="dropList width60">
            <div class="dropList__left">清仓净值</div>
            <div class="dropList__right">
              {{ dataObj.latestNetWorth }}({{
                formatDate(dataObj.netWorthDate)
              }})
            </div>
          </div>
          <div class="dropList width40">
            <div class="dropList__left">成本净值</div>
            <div
              class="dropList__right"
              v-if="getValueStatus(dataObj.netCost) == '2'"
            ></div>
            <div
              class="dropList__right"
              v-if="getValueStatus(dataObj.netCost) == '4'"
            >
              --
            </div>
            <div class="dropList__right" v-else>
              {{ dataObj.netCost ? (dataObj.netCost * 1).toFixed(4) : "" }}
            </div>
          </div>
          <div class="dropList width60">
            <div class="dropList__left">累计现金分红金额</div>
            <template v-if="getValueStatus(cashDividendAmount) == '1'">
              <div class="dropList__right reduceStyle">
                {{ cashDividendAmount }}
              </div>
            </template>
            <template v-if="getValueStatus(cashDividendAmount) == '2'">
              <div class="dropList__right">0.00</div>
            </template>
            <template v-if="getValueStatus(cashDividendAmount) == '4'">
              <div class="dropList__right">--</div>
            </template>
            <template v-if="getValueStatus(cashDividendAmount) == '3'">
              <div class="dropList__right addStyle">+{{ cashDividendAmount }}</div>
            </template>
          </div>

          <div class="dropList width60" v-if="monthKnot">
            <div class="dropList__left">未兑付收益</div>
            <template v-if="getValueStatus(unpaidEarnings) == '1'">
              <div class="dropList__right reduceStyle">
                {{ unpaidEarnings }}
              </div>
            </template>
            <template v-if="getValueStatus(unpaidEarnings) == '2'">
              <div class="dropList__right">0.00</div>
            </template>
            <template v-if="getValueStatus(unpaidEarnings) == '4'">
              <div class="dropList__right">--</div>
            </template>
            <template v-if="getValueStatus(unpaidEarnings) == '3'">
              <div class="dropList__right addStyle">+{{ unpaidEarnings }}</div>
            </template>
          </div>

        </div>
        <div class="dropMoreDetail" v-show="showDropContent && isMonetaryFund">
          <div class="dropList width60">
            <div class="dropList__left">累计收益</div>
            <div class="dropList__right">
              {{ dataObj.cumulativeIncome ? dataObj.cumulativeIncome: '--' }}
            </div>
          </div>
          <div class="dropList width40">
            <div class="dropList__left">持有份额</div>
            <div
              class="dropList__right"
              v-if="getValueStatus(dataObj.holdShare) == '4'"
            >
              --
            </div>
            <div class="dropList__right" v-else>{{ dataObj.holdShare }}</div>
          </div>
          
          <div class="dropList width60">
            <div class="dropList__left">万份收益 </div>
            <template v-if="getValueStatus(fundIncome) == '1'">
              <div class="dropList__right ">
                {{ fundIncome }} ({{
                formatDate(dataObj.fundIncomeDate)
              }})
              </div>
            </template>
            <template v-if="getValueStatus(fundIncome) == '2'">
              <div class="dropList__right">0.00({{
                formatDate(dataObj.fundIncomeDate)
              }})</div>
            </template>
            <template v-if="getValueStatus(fundIncome) == '4'">
              <div class="dropList__right">--</div>
            </template>
            <template v-if="getValueStatus(fundIncome) == '3'">
              <div class="dropList__right ">{{ fundIncome }}({{
                formatDate(dataObj.fundIncomeDate)
              }})</div>
            </template>
          </div>
          <div class="dropList width40">
            <div class="dropList__left">成本净值</div>
            <div
              class="dropList__right"
              v-if="getValueStatus(dataObj.netCost) == '2'"
            ></div>
            <div
              class="dropList__right"
              v-if="getValueStatus(dataObj.netCost) == '4'"
            >
              --
            </div>
            <div class="dropList__right" v-else>
              {{ dataObj.netCost ? (dataObj.netCost * 1).toFixed(4) : "" }}
            </div>
          </div>

          <div class="dropList width60" v-if="monthKnot">
            <div class="dropList__left">未兑付收益</div>
            <template v-if="getValueStatus(unpaidEarnings) == '1'">
              <div class="dropList__right reduceStyle">
                {{ unpaidEarnings }}
              </div>
            </template>
            <template v-if="getValueStatus(unpaidEarnings) == '2'">
              <div class="dropList__right">0.00</div>
            </template>
            <template v-if="getValueStatus(unpaidEarnings) == '4'">
              <div class="dropList__right">--</div>
            </template>
            <template v-if="getValueStatus(unpaidEarnings) == '3'">
              <div class="dropList__right addStyle">+{{ unpaidEarnings }}</div>
            </template>
          </div>

        </div>
       
      </div>
      <div
        class="tradingList"
        v-if="
          dataObj.inTransitTransactions &&
          dataObj.inTransitTransactions.length > 0
        "
      >
        <div
          class="tradingItem"
          v-for="(item, index) in dataObj.inTransitTransactions"
          :key="index"
        >
          <span class="dotted"></span>
          <span class="buyDetail">{{ item }}</span>
        </div>
      </div>
      <div class="fundChart">
        <fund-chart :tabList="fundTab1" v-if="isMonetaryFund" :key="componentKey"></fund-chart>
        <fund-chart :tabList="fundTab" v-else :key="componentKey"></fund-chart>
      </div>
      <div class="transactionDetail" @click="goTradePage">
        <div class="transactionDetail__left">交易明细</div>
        <div class="transactionDetail__right">
          <div class="sureTransaction" v-if="!!dataObj.quantityToBeConfirmed">
            {{ dataObj.quantityToBeConfirmed }}笔待完成
          </div>
          <van-icon name="arrow" class="customIcon" />
        </div>
      </div>
      <div class="investmentBox" v-if="!isMonetaryFund">
        <invesment></invesment>
      </div>
      <div class="transactionDetail" v-if="dataObj.cashDividendVoList && dataObj.cashDividendVoList.length" @click="dividendsAmountClick">
        <div class="transactionDetail__left flex">现金分红记录</div>
        <div class="transactionDetail__right">
          <div class="normalStyle totalAmount" v-if="dataObj.cashDividendAmount">总金额(元)：{{dataObj.cashDividendAmount | formatMoney}}</div>
          <van-icon name="arrow" class="customIcon devide-arrow" />
        </div>
      </div>
      <div class="transactionDetail" v-if="dataObj.dividendMethod">
        <div class="transactionDetail__left flex">分红方式
          <img class="audit" src="@/assets/images/icons/questionMark.png" alt="" @click="divideDes">
        </div>
        <div class="transactionDetail__right" @click="dividendClick">
          <div class="normalStyle normal-width" v-if="dataObj.dividendMethodReview">{{ dividendMethodArr[dividendMethod] }}(变更中)</div>
          <div class="normalStyle" v-else>{{ dividendMethodArr[dividendMethod] }}</div>
          <van-icon name="arrow" v-if="dataObj.dividendMethodUpdate" class="customIcon" />
        </div>
      </div>

      <div class="transactionDetail">
        <div class="transactionDetail__left">管理人</div>
        <div class="transactionDetail__right">
          <div class="normalStyle">{{ managerName }}</div>
        </div>
      </div>
      <div class="riskTip">
        风险提示:投资有风险。基金的过往业绩及其净值高低并不预示其未来表现。
        基金管理人管理的其他基金的业绩并不构成基金业绩表现的保证。
        相关数据仅供参考，不构成投资建议。投资人请详阅基金合同和基金招募说明书，并自行承担投资风险。
      </div>
      <!-- 0-可申购赎回 1-发行 2-发行成功 3-发行失败 4-停止申购赎回 5-停止申购 6-停止赎回 8-基金终止 9-基金封闭 -->
      <div
        class="fixedBtn"
        v-if="typeof isFinished == 'boolean' && isFinished"
        :class="{ hairPhone: isIphone }"
      >
        <div
          class="fixedBtn__list normalBtn"
          :class="canRedeem ? '' : 'grey'"
          @click="handleSold"
        >
          {{ canRedeem ? "卖出" : "暂停赎回" }}
        </div>
        <div
          class="fixedBtn__list normalBtn"
          :class="canRedeem ? 'fixedInvest' : ''"
          @click="goToFixedInves"
          v-if="
            isSupportFixedInt == '1' &&
            userType == '1' &&
            certificateType == '0'
          "
        >
          定投
        </div>
        <div
          class="fixedBtn__list primaryBtn"
          :class="canBooking ? '' : 'grey'"
          @click="handleBuy"
        >
          {{ canBooking ? "买入" : "暂停申购" }}
        </div>
      </div>
    </div>
  </van-pull-refresh>
    <div>
      <divide-popup ref="divideRef"></divide-popup>
    </div>
  </div>
  <tips :content="tipsContent" ref="tipComponent"></tips>
</div>
</template>

<script>
import fundChart from "@views/publicFunds/fundChart.vue";
import invesment from "@views/publicFunds/investment.vue";
import tips from '@views/assets/tips.vue';
import { mapState } from "vuex";
import { PullRefresh, Toast } from "vant";
import { getValueStatus } from "@/util/util";
import {WATERMARK} from '../../util/util'
import dividePopup from '../../components/divideTips.vue'
import keepAlive from "@/util/keepAlive.js";
export default {
  name: "survivalDetail",
  components: {
    fundChart,
    invesment,
    dividePopup,
    [PullRefresh.name]: PullRefresh,
    tips
  },
  data() {
    return {
      componentKey:0,
      isLoading: false,
      showDropContent: true,
      companyId: "", //主体
      orgCommonId: "", //公司客户公共表主键ID
      groupCommonId: "", //集团客户公共表主键ID
      deviceId: "",
      ip: "",
      eye_open: false,
      groupId: "",
      productId: this.$route.query.productId || "", //母产品ID
      productName: this.$route.query.fundName || "", //基金名称
      sysContractNo: this.$route.query.sysContractNo || "", //系统合同号
      fundTab: [
        {
          moduleName: "业绩走势",
          moduleComponent: "pubTrajectory",
        },
      ],
      fundTab1: [
        {
          moduleName: "累计收益",
          moduleComponent: "pubCumulativeIncome",
        },
        {
          moduleName: "七日年化收益走势",
          moduleComponent: "pubAnnualizedTrend",
        },
      ],
      dividendMethodArr:["红利再投资", "现金分红"],
      dataObj: {},
      positionAmount: "",
      yesterdaySEarnings: "",
      positionIncome: "",
      holdingRateOfReturn: "",
      dailyIncrease: "",
      dividendMethod: "",
      monthKnot: false, //是否月结型基金
      unpaidEarnings: "", //未兑付收益
      riskLevel: "", //低风险,中低风险,中风险,中高风险,高风险
      riskLevelValue: "",
      fundType: "", //
      showRiskImg: null,
      isSupportFixedInt: "", //是否支持定投
      userType: "", //客户类型
      certificateType: "", //证件类型
      managerName: "", //管理人
      isFinished: null,
      canRedeem: null, //赎回
      haveShare: null,//是否有份额
      canBooking: null, //买入
      isMonetaryFund: false, //是否货币基金
      fundIncome: '',
      scrollPosition: 0,
      marginTopNum:"",
      dontScrollFlag:'0',
      cumulativeIncome:"",//累计收益/浮动盈亏/清仓收益
      cumulativeRate:"",//累计收益率/浮动盈亏/清仓收益（收益率） 累计收益率=累计收益/正向交易金额
      cashDividendAmount:"",//累计现金分红金额
      tipsContent:[
          {
          title:'持有金额',
          text:["持有金额=持有份额*最新单位净值"]
          },
          {
          title:'昨日收益',
          text:["昨日收益=Σ(昨日持有份额*(昨日单位净值-前日单位净值)+昨日现金分红-昨日手续费)"]
          },
          {
          title:'持有收益',
          text:["持有收益=期末持有份额*（最新净值-成本净值）","持有收益率=持有收益/（期末持有份额*成本净值）其中，成本净值=（Σ 买入类业务确认金额-Σ 现金分红金额）/Σ 买入类业务确认份额"]
          },
          {
          title:'浮动盈亏',
          text:["浮动盈亏=持有金额+赎回金额+现金分红-投资金额","浮动盈亏收益率=浮动盈亏/投资金额"]
          },
          {
          title:'清仓收益',
          text:["清仓收益=全部赎回金额+现金分红-投资金额","清仓收益率=清仓收益/投资金额"]
          }
      ],
    };
  },
  mixins:[keepAlive],
  computed: {
    ...mapState([
      "personalAccount",
      "parentIdInfo",
      "curFundId",
      "statusHeight",
      "getHeadInfo",
      "scrollPositions"
    ]),
    isIphone() {
      if (this.statusHeight.isIphoneX && this.statusHeight.isIphoneX === "1") {
        return true;
      }
      return false;
    },
    isHistoryData() {
      return this.parentIdInfo.isHistoryData;
    }
  },
  created() {
    let heig = Number(this.statusHeight.statusBar_height);
    let newH = heig + 48;
    let data = newH / 100 + "rem";
    this.marginTopNum = data;
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
          console.log('beforeRouteEnter--scrollPosition',vm.scrollPosition)
          if (vm.scrollPosition>0) {
            document.querySelector('.allPage').scrollTo(0, vm.scrollPosition);
          }
    });
  },
  activated() {
    if(this.$route.meta.useCatch){
      this.getDetail();
      this.componentKey +=1;
    }
  },
  mounted() {
    document.getElementById("survivalDetail").style.marginTop = this.marginTopNum;
    document.getElementById("survivalDetail").style.height = `calc ( 100vh - ${this.marginTopNum})`;
    document.querySelector('.allPage').addEventListener('scroll',this.scrollHanler);
  },
  beforeRouteLeave(to, from, next) { 
    if (to.path == "/publicFundsDetail") {
      this.$store.commit("routerJump", "cx_detail");
      next()
      return
    }
    // if (to.path !== '/fundContrast') {
      // this.fromVNode.meta.keepAlive = false
    // }
    next()
  },
  watch: {
    statusHeight: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.$nextTick(() => {
            let heig = Number(this.statusHeight.statusBar_height);
            let newH = heig + 48;
            let data = newH / 100 + "rem";
            let $dom = document.getElementById("survivalDetail");
            $dom.style.marginTop = data;
            this.scrollTopNum = data;
            $dom.style.height = `calc(100vh - ${data})`;
          });
        }
      },
      deep: true,
      immediate: true
    },
    "personalAccount.companyId": {
      handler(newVal) {
        if (newVal) {
          let {
            orgCommonId,
            groupCommonId,
            companyId,
            deviceId,
            ip,
            eye_open,
            groupId,
            userType,
          } = this.personalAccount;
          this.orgCommonId = orgCommonId || "";
          this.groupCommonId = groupCommonId || "";
          this.companyId = companyId || ""; //主体 1-陆享 2-陆浦 3-店中店
          this.deviceId = deviceId || "";
          this.ip = ip || "";
          this.eye_open = eye_open;
          this.groupId = groupId || "";
          this.userType = userType || "";
          let trendParams = {
            orgCommonId: this.orgCommonId,
            companyId: this.companyId,
            productId: this.personalAccount.productId,
            groupCommonId: this.groupCommonId,
            sysContractNo: this.sysContractNo,
          };
          this.$store.commit("changeTrendParams", trendParams);
          this.getDetail();
          this.$store.commit("changeSurvivalType", 1); // 存续类型//1公募，2私募
        }
      },
      immediate: true,
    },
  },
  methods: {
    getValueStatus,
    onRefresh() {
      setTimeout(() => {
        this.isLoading = false;
        let {
            orgCommonId,
            groupCommonId,
            companyId,
            deviceId,
            ip,
            eye_open,
            groupId,
            userType,
            productId
          } = this.personalAccount;
          this.orgCommonId = orgCommonId || "";
          this.groupCommonId = groupCommonId || "";
          this.companyId = companyId || ""; //主体 1-陆享 2-陆浦 3-店中店
          this.deviceId = deviceId || "";
          this.ip = ip || "";
          this.eye_open = eye_open;
          this.groupId = groupId || "";
          this.userType = userType || "";
          let trendParams = {
            orgCommonId: this.orgCommonId,
            companyId: this.companyId,
            productId: productId || "",
            groupCommonId: this.groupCommonId,
            sysContractNo: this.sysContractNo,
          };
          this.componentKey +=1;
          this.$store.commit("changeTrendParams", trendParams);
          this.getDetail();
          this.$store.commit("changeSurvivalType", 1); // 存续类型//1公募，2私募
      }, 1000);
    },
    scrollHanler(){
      const bodyWrapper = document.querySelector('.allPage');
      this.scrollPosition = bodyWrapper.scrollTop;
    },
    getDetail() {
      this.$store.commit("changeEnforceFlag", "1");
      let _this = this;
      let params = {
        //私募多一个subProductId参数
        companyId: this.companyId,
        orgCommonId: this.orgCommonId,
        groupCommonId: this.groupCommonId,
        productId: this.curFundId || this.personalAccount.productId,
        sysContractNo:
          this.personalAccount.sysContractNo ||
          this.parentIdInfo.sysContractNo ||
          "",
      };
      this.$post(this.$api.pubRemaining, params).then((res) => {
        if (res.code === 10000) {
          WATERMARK('存续详情','assetPublic','','',this.curFundId || this.personalAccount.productId)
          _this.isFinished = true;
          _this.dataObj = res.data || {};
          console.log('公募存续详情接口返回：：：：：：：：',res.data)
        
          this.cumulativeRate = res.data.cumulativeRate;
          this.cumulativeIncome = res.data.cumulativeIncome;
          // console.log('lockTitle',_this.dataObj.lockTitle)
          _this.cashDividendAmount = res.data.cashDividendAmount;
          _this.dataObj.netCost = res.data.netCost;
          _this.positionAmount = res.data.positionAmount;
          _this.yesterdaySEarnings = res.data.yesterdaySEarnings;
          _this.positionIncome = res.data.positionIncome;
          _this.holdingRateOfReturn = res.data.holdingRateOfReturn;
          _this.dailyIncrease = res.data.dailyIncrease
            ? (res.data.dailyIncrease * 1).toFixed(2)
            : "";
          _this.fundIncome = res.data.fundIncome
            ? (res.data.fundIncome * 1).toFixed(4)
            : "";
          _this.dividendMethod = res.data.dividendMethod || "1";
          _this.riskLevelValue = res.data.riskLevelValue;
          _this.riskLevel = res.data.riskLevel;
          _this.fundType = res.data.fundType;
          _this.monthKnot = res.data.monthKnot;
          _this.unpaidEarnings = res.data.unpaidEarnings;
          if(res.data.fundType=='货币型'){
            this.isMonetaryFund = true
          }else{
            this.isMonetaryFund = false
          }
          _this.managerName = res.data.managerName || "";
          _this.certificateType = res.data.certificateType || "";
          _this.canRedeem = res.data.canRedeem;
          _this.haveShare = res.data.haveShare;
          _this.canBooking = res.data.canBooking;
          if (
            _this.riskLevel == "中风险" ||
            _this.riskLevel == "中高风险" ||
            _this.riskLevel == "高风险"
          ) {
            _this.showRiskImg = true;
          }
          let baseData = {
            deviceId: this.deviceId,
            ip: this.ip,
            groupCommonId: this.groupCommonId,
            orgCommonId: this.orgCommonId,
            productId:
              this.parentIdInfo.parentId || this.personalAccount.productId,
            riskLevel: this.riskLevel,
            riskLevelValue: this.riskLevelValue,
            typeOfPurchase: 1,
          };
          this.$store.commit("getBaseData", baseData);
          let openAccount = {
            deviceId: this.deviceId,
            ip: this.ip,
            groupCommonId: this.groupCommonId,
            orgCommonId: this.orgCommonId,
            productId:
              this.parentIdInfo.parentId || this.personalAccount.productId,
            riskLevel: this.riskLevel,
            riskLevelValue: this.riskLevelValue,
            typeOfPurchase: 1,
            eye_open: this.eye_open,
            groupId: this.groupId,
            showFrontPage: this.dataObj.showFrontPage,
            frontPageUrl: this.dataObj.frontPageUrl,
          };
          _this.$store.commit("changeOpenAccount", openAccount);
          _this.$store.commit("changeEnforceFlag", "0");
          _this.$store.commit("chanLoadingStatus", false);
          let dataPro = {
            ...this.personalAccount,
            productId:
              this.parentIdInfo.parentId || this.personalAccount.productId,
            sysContractNo:
              this.parentIdInfo.sysContractNo ||
              this.personalAccount.sysContractNo,
          };
          if (!this.IOS.ios()) {
             window.android.postSaveData(JSON.stringify({...dataPro}));
            }
        } else {
          _this.$store.commit("changeEnforceFlag", "0");
          _this.$store.commit("chanLoadingStatus", false);
          _this.$toast(res.message);
        }
      });
    },
    //现金分红金额记录
    dividendsAmountClick() {
      this.$router.push({
        path: '/dividendDetail',
        query:{
          dividendModeList: this.dataObj?.cashDividendVoList || [],
        }
      })
    },
    //
    toastInfo() {
      this.$refs.tipComponent.showTips = true;
    },
    //卖出
     handleSold() {
      if (this.canRedeem===false) return;
      if (this.canRedeem===true && this.haveShare===false) {
        this.$toast("您的可赎回份额为0，暂时无法赎回");
        return
      }
      let objIos = {
        productId: this.curFundId || this.personalAccount.productId,
        sysContractNo:
          this.personalAccount.sysContractNo ||
          this.parentIdInfo.sysContractNo ||
          "",
      };
      if (this.IOS.ios()) {
        window.webkit.messageHandlers.publicProductRedemption.postMessage(objIos);
      } else {
        let productId = this.productId || this.personalAccount.productId || this.curFundId
        window.android.publicProductRedemption(productId);
      }
    },
    //定投
    goToFixedInves() {
      let params = {
        productId: this.productId || this.personalAccount.productId || this.curFundId,
      };
      if (this.IOS.ios()) {
        window.webkit.messageHandlers.publicFixedPlan.postMessage(params);
      } else {
        window.android.publicFixedPlan(JSON.stringify(params));
      }
    },
    //买入
    handleBuy() {
      if (this.canBooking === false) return;
      // let objIos = {
      //   productId: this.curFundId || this.personalAccount.productId,
      //   sysContractNo:
      //     this.personalAccount.sysContractNo ||
      //     this.parentIdInfo.sysContractNo,
      //     productName:this.productName
      // };
      let productId = this.curFundId || this.personalAccount.productId || this.productId
      let productName = this.productName || this.personalAccount.productName
      if (this.IOS.ios()) {
        window.webkit.messageHandlers.publicOfferingBuy.postMessage(productId, productName);
      } else {
        window.android.publicOfferingBuy(productId, productName);
      }
    },
    
    //日期
    formatDate(data) {
      if (data) {
        return dayjs(data).format("MM-DD");
      } else {
        return "";
      }
    },
    //投资检视
    entryInvestment() {
      this.$router.push("/investmentRe");
    },
    //交易明细
    goTradePage() {
      let params = {
        source: "0",
        productId: this.productId || this.personalAccount.productId || this.curFundId ,
        sysContractNo:
          this.personalAccount.sysContractNo ||
          this.parentIdInfo.sysContractNo
      };
      if (this.IOS.ios()) {
        window.webkit.messageHandlers.gotoTransactionList.postMessage(params);
      } else {
        window.android.gotoTransactionList(JSON.stringify(params));
      }
    },
    toShareDetail(){
      this.$router.push({
        path: '/shareDetail',
        query:{
            productId: this.$route.query.productId
        }
      })
    },
    dividendClick() {
      if (!this.dataObj.dividendMethodUpdate) {
        return
      }
      this.$router.push({
        path: '/modifyDividendWay',
        query:{
            isPrivate: false,
            dividendMethod: this.dividendMethod,
            productId: this.curFundId || this.personalAccount.productId,
            dividendModeList: JSON.stringify(this.dataObj?.dividendModeVos || []),
            sysContractNo: this.personalAccount.sysContractNo || this.parentIdInfo.sysContractNo || ""
        }
      })
    },
    goDivideListPage() {
      this.$router.push({
        path: "/dividendList",
        query:{
          dividendModes: JSON.stringify(this.dataObj.dividendModeVos)
        }
      });
    },
    divideDes() {
      this.$refs.divideRef.isShowPopup = true;
    }
  },
  destroyed(){
    this.componentKey = 0;
  }
};
</script>

<style scoped lang="scss">
[v-cloak] {
  display: none;
}
// .allPage /deep/.van-pull-refresh {
//   height: calc(100vh - 100px) !important;
//   overflow: auto !important;
// }
.allPage {
  position:absolute;
  top:0;
  left: 0;
  height:100vh;
  width: 100%;
  background-color: #F5F5F5;
  box-sizing: border-box;
  z-index: 1;
  overflow: auto;
}
::-webkit-scrollbar {
  display: none;
}
.flexCenter {
  display: flex;
  align-items: center;
  justify-content: center;
}
.subOpacity {
  font-size: 0.13rem;
  opacity: 0.7;
}
.primaryPage {
  background-color: #f5f5f5;
  padding-bottom: 0.7rem;
  .fundDetail {
    background-color: #fff;
    .fund-name {
      padding: 0.16rem 0.16rem 0;
      text-align: left;
      .fundN {
        font-size: 0.18rem;
        color: #333333;
        font-weight: bold;
      }
      .fundLabel {
        width: 100%;
        display: flex;
        flex-direction: row;
        .fundC {
          font-size: 0.15rem;
          color: #999999;
          padding-top: 0.05rem;
        }
        .risk {
          display: flex;
          align-items: center;
          flex-direction: row;
          font-size: 0.1rem;
          color: #1c6ad7;
          padding: 0rem 0.1rem;
          border-radius: 0.04rem;
          background: #ebf3ff;
          margin-left: 0.08rem;
          .risk_img {
            width: 0.1rem;
            height: 0.12rem;
            margin-right: 0.05rem;
          }
          .risk_txt {
            font-size: 0.12rem;
            color: #1677ff;
          }
        }
      }
    }
    .investmentT {
      display: flex;
      justify-content: flex-end;
      margin-bottom: 0.1rem;
      &__des {
        padding: 0.04rem 0;
        width: 0.8rem;
        text-align: center;
        background-color: #d92616;
        color: #fff;
        font-size: 0.13rem;
        font-weight: bold;
        border-top-left-radius: 0.2rem;
        border-bottom-left-radius: 0.2rem;
      }
    }
    .allSurvival {
      padding: 0.05rem 0 0;
      @extend .flexCenter;
      color: #666666;
      &__span {
        font-size: 0.13rem;
      }
      /deep/.van-icon {
        font-size: 0.16rem;
        margin-left: 0.08rem;
      }
      
      &__tag {
        height: 0.16rem;
        line-height: 0.16rem;
        font-size: 0.1rem;
        text-align: left;
        background: #FEE2E2;
        color: #E12817;
        padding: 0.01rem 0.05rem;
        margin-top: 4px;
        border-radius: 2px;
        box-sizing: border-box;
      }
    }
    .mineSurvival {
      margin-top: 0.08rem;
      &__Num {
        font-weight: bold;
        font-size: 0.34rem;
        color: #e12817;
      }
      .normal {
        color: #333;
      }
    }
    .lockingShare {
      @extend .flexCenter;
      position: relative;
      padding: 0;
      &__span {
        min-width: 1.92rem;
        background: #F5F5F5;
        padding: 0.1rem 0.18rem;
        font-size: 0.14rem;
        border-radius: 0.5rem;
        .lockingShare__count {
          font-size: 0.18rem;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #333333;
        }
      }
    }
    .lockingShare::after {
      position: absolute;
      top: -8px;
      left: 0;
      content: '';
      left: 50%;
      transform: translate(-50%,-50%);
      width: 0;
      height: 0;
      border: 8px solid;
      border-color:  transparent transparent #F5F5F5 transparent;
    }
    .survivalList {
      padding: 0.24rem 0;
      box-sizing: border-box;
      display: flex;
      &__item {
        width: 33.3333%;
        display: flex;
        flex-direction: column;
        align-items: center;
        color: #666;
        .top {
          font-size: 0.13rem;
        }
        .bottom {
          margin-top: 0.03rem;
          font-weight: bold;
          font-size: 0.2rem;
          color: #666;
        }
        .green {
          color: #00b578;
        }
        .red {
          color: #e12817;
        }
      }
    }
    .dropMore {
      text-align: center;
      font-size: 0.14rem;
      color: #1677ff;
    }
    .dropMoreDetail {
      background-color: #faf9f9;
      padding: 0 0.16rem 0.16rem;
      border-top: 1px solid #eeeeee;
      border-bottom: 1px solid #eeeeee;
      display: flex;
      flex-wrap: wrap;
      position: relative;
      .dropList {
        margin-top: 0.16rem;
        text-align: left;
        display: flex;
        align-items: center;
        font-size: 0.13rem;
        color: #666666;
        &__left {
          margin-right: 0.04rem;
        }
        .reduceStyle {
          color: #00b578 !important;
        }
        .addStyle {
          color: #e12817 !important;
        }
      }
      .width60 {
        width: 57%;
      }
      .width40 {
        width: 43%;
      }
      &:after {
        position: absolute;
        top: -0.05rem;
        left: 50%;
        transform: translateX(-50%) rotate(45deg);
        content: "";
        width: 0.1rem;
        height: 0.1rem;
        background-color: #faf9f9;
        border-top: 1px solid #eeeeee;
        border-left: 1px solid #eeeeee;
      }
    }
  }
  .tradingList {
    background-color: #fff;
    padding: 0 0.16rem;
    .tradingItem {
      display: flex;
      align-items: center;
      font-size: 0.14rem;
      color: #666666;
      border-bottom: 1px solid #eeeeee;
      padding: 0.16rem 0;
      &:last-of-type {
        border: none;
      }
      &:first-of-type {
        margin-top: 0.16rem;
      }
      .dotted {
        width: 0.03rem;
        height: 0.03rem;
        background-color: #666666;
        border-radius: 50%;
      }
      .buyDetail {
        margin-left: 0.08rem;
        margin-right: 0.24rem;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        height: 0.3rem;
        line-height: 0.3rem;
      }
    }
  }
  .fundChart {
    margin-top: 0.16rem;
  }
  .transactionDetail {
    background-color: #fff;
    padding: 0.16rem;
    margin-top: 0.16rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .flex {
      display: flex;
      flex-direction: row;
      align-items: center;
      width: 2rem;
      .audit {
        padding-left: 0.08rem;
        width: 0.16rem;
        height: 0.16rem;
      }
    }
    &__left {
      font-size: 0.15rem;
      color: #333333;
      width: 0.8rem;
      text-align: left;
      font-family: PingFangSC-Regular, PingFang SC;
    }
    &__right {
      display: flex;
      align-items: center;
      .sureTransaction {
        font-size: 0.15rem;
        color: #e12817;
      }
      .normalStyle {
        font-family: PingFangSC-Regular, PingFang SC;
        font-size: 0.15rem;
        line-height: 0.21rem;
        color: #666666;
      }
      .totalAmount {
        text-align: right;
        color: #e12817;
        min-width: 2.2rem;
      }
      .normal-width {
        width: 1.5rem;
      }
      .customIcon {
        margin-left: 0.04rem;
        font-size: 0.15rem;
        color: #999999;
      }
    }
  }
  .riskTip {
    padding: 0.24rem 0.16rem;
    font-size: 0.11rem;
    color: #cccccc;
    line-height: 0.18rem;
    text-align: left;
  }
  .fixedBtn {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    z-index: 999;
    &__list {
      flex: 1;
      height: 0.6rem;
      line-height: 0.6rem;
      box-sizing: border-box;
      text-align: center;
      font-size: 0.17rem;
      border-top: 1px solid #eeeeee;
      border-bottom: 1px solid #eeeeee;
    }
    .fixedInvest {
      position: relative;
    }
    .fixedInvest::before {
      position: absolute;
      top: 0.15rem;
      left: 0;
      content: "";
      width: 1px;
      height: 0.2rem;
      background: #eee;
    }
    .normalBtn {
      background-color: #fff;
      color: #e12817;
    }
    .primaryBtn {
      background-color: #e12817;
      border-top: 1px solid #e12817;
      border-bottom: 1px solid #e12817;
      color: #ffffff;
    }
    .grey {
      background-color: #eee;
      color: #666;
    }
  }
}
.hairPhone {
  height: 0.8rem;
  background-color: #fff;
  color: rgb(110, 106, 106);
  .flexLayout {
    height: 0.6rem;
  }
}
.popoverDetail {
  padding: 0 0.08rem;
  box-shadow: 0 1px 1px rgba(147, 147, 147, 0.3);
  .popoverItem {
    text-align: center;
    font-size: 0.14rem;
    color: #333333;
    padding: 0.1rem 0.18rem;
    border-bottom: 1px solid #eeeeee;
    &__left {
      font-size: 0.15rem;
      color: #333333;
    }
  }
}
</style>